export default __webpack_public_path__ + "locales/fi/Translations.json?hash=c1ef9159e973afa81252c7761d025cb4";